import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PermissionTable from "./PermissionTable";
import { useLocation } from "react-router-dom";
import { fetchFormData } from "../../utils/options";
const PermissionList = () => {

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <div className="main-content">
            <div className="row">
              <PermissionTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default PermissionList;
